var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB80"
    },
    d: "M0,244.87V44.522C0,19.933,19.933,0,44.522,0h166.957C236.066,0,256,19.933,256,44.522V244.87H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB99"
    },
    d: "M256,44.522V244.87H128V0h83.478C236.066,0,256,19.933,256,44.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D15D39"
    },
    d: "M0,77.913V44.522C0,19.933,19.933,0,44.522,0h166.957C236.066,0,256,19.933,256,44.522v33.391H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967A56"
    },
    d: "M367.304,233.739V122.435c-12.295,0-22.261-9.966-22.261-22.261l0,0 c0-12.295,9.966-22.261,22.261-22.261h66.783c12.295,0,22.261,9.966,22.261,22.261l0,0c0,12.295-9.966,22.261-22.261,22.261v111.304 H367.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B79969"
    },
    d: "M47.766,456.348h-3.245C19.933,456.348,0,436.414,0,411.826V211.478h467.478 C492.066,211.478,512,231.412,512,256v155.826c0,24.588-19.933,44.522-44.522,44.522H47.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C443B"
    },
    d: "M512,300.522v111.304c0,24.588-19.933,44.522-44.522,44.522H47.766h-3.245 C19.933,456.348,0,436.414,0,411.826V300.522H512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A9390"
    },
    d: "M44.522,422.957c0-49.178,39.866-89.043,89.043-89.043s89.043,39.866,89.043,89.043 S182.743,512,133.565,512S44.522,472.134,44.522,422.957z M411.826,512c30.736,0,55.652-24.917,55.652-55.652 s-24.917-55.652-55.652-55.652s-55.652,24.917-55.652,55.652S381.09,512,411.826,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAB250"
    },
    d: "M100.174,422.957c0-18.442,14.949-33.391,33.391-33.391s33.391,14.949,33.391,33.391 s-14.949,33.391-33.391,33.391S100.174,441.399,100.174,422.957z M411.826,478.609c12.295,0,22.261-9.966,22.261-22.261 s-9.966-22.261-22.261-22.261c-12.295,0-22.261,9.966-22.261,22.261S399.531,478.609,411.826,478.609z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.6e5f2089a58537e18bab82b237a6211d.svg";
export { ForwardRef as ReactComponent };